import React from "react";
import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Row,
  Col,
} from "reactstrap";
import { getActiveColorStyle } from "../../utils/colorUtils";

const AccountParameters = ({ activeColor = "secondary" }) => {
  // Get active color style
  const activeColorStyle = getActiveColorStyle(activeColor);

  return (
    <div className="content">
      <Row>
        <Col md="12">
          <Card>
            <CardHeader>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <CardTitle tag="h4" style={{ margin: 0 }}>Account Parameters</CardTitle>
              </div>
            </CardHeader>
            <CardBody>
              <div style={{ 
                display: 'flex', 
                justifyContent: 'center', 
                alignItems: 'center', 
                minHeight: '200px',
                color: '#6c757d',
                fontSize: '16px'
              }}>
                Account Parameters content will be added here...
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default AccountParameters; 